














import { Component } from 'vue-property-decorator';
import Vue from 'vue';

@Component<AuthenticationWrapper>({})
export default class AuthenticationWrapper extends Vue {}
